export const en = {
  'already_logout': 'logout, please re-login',
  'logout': 'Log out',
  'user_login': 'User log in',
  'username': 'Username',
  'password': 'Password',
  'login': 'Log in',
  'edit_password': 'Edit password',
  'hide_video': 'Hide video',
  'view_video': 'View video',
  'slow_audio_playback': 'Slow audio playback',
  'video_transcript': 'Video transcript',
  'conversation_mission': 'Conversation mission',
  'wordBank': 'Word bank',
  'highlights': 'Highlights',
  'slow_playback': 'Slow playback',
  'view_translation': 'View translation',
  'dictionary': 'Dictionary',
  'fill_in_the_blanks': 'Fill in the blanks',
  'multiple_choice': 'Multiple choice',
  'complete_the_sentence': 'Complete the sentence',
  'unscramble_the_sentences': 'Unscramble the sentences',
  'the_assessment_begin_description': 'The assessment is about to begin. There are 4 parts in this test: listening, vocabulary, grammar, and reading. Each part contains 12-16 questions. Level of questions will be adjusted according to accuracy of answer.',
  'start_test': 'Start',
  'next': 'Next',
  'assessment_completed_description': 'Assessment completed. Thank you for taking the test!',
  'recommendation_according_assessment_result': 'Several courses are recommended to you based on your assessment result. You can view test result or the recommendation.',
  'view_result': 'View result',
  'my_recommendation': 'My recommendation',
  'view_assessment_history': 'View Assessment history',
  'assessment': 'Assessment',
  'view_recommendation': 'View recommendation',
  'assessment_history': 'Assessment history',
  'view_list': 'Back',
  'detail': 'Detail',
  'assessment_test': 'Assessment test',
  'listening_skill': 'Listening skill',
  'reading_skill': 'Reading skill',
  'vocabulary_skill': 'Vocabulary skill',
  'grammar_skill': 'Grammar skill',
  'test_date': 'Test date',
  'period': 'Period',
  'title': 'Title',
  'assigned_by': 'Assigned by',
  'listening': 'Listening',
  'reading': 'Reading',
  'total': 'Total',
  'status': 'Status',
  'take_test': 'Take test',
  'n_a': 'N/A',
  'not_released': 'Not released',
  'test_is_over': 'Test is over',
  'go_test': 'Start Test',
  'completed': 'Completed',
  'no_test_found': 'No test found',
  'my_test': 'My test',
  'new_test': 'New test',
  'added_on': 'Added on',
  'assignment_history': 'Assignment history',
  'assign': 'Assign',
  'edit': 'Edit',
  'view_score': 'View score',
  'view': 'View',
  'delete': 'Delete ',
  'assignment_deleting_notice': 'By deleting the assignment, you will also delete the test record.',
  'deleting_confirm': 'Are you sure you want to delete?',
  'warming_remind': 'Warming! The deleted item cannot be restored.',
  'yes': 'OK',
  'cancel': 'Cancel',
  'deleted': 'Deleted',
  'class_deleted': 'The script was successfully deleted!',
  'has_been_assigned_to': 'has been assigned to',
  'no_assignment_has_been_made': 'No assignment has been made',
  'deleting_assignment_confirm': 'Are you sure you want to delete assignment?',
  'assign_to': 'Assign [{msg}] to',
  'no_class_is_assigned': 'No class is assigned',
  'submit_assign': 'Submit',
  'set_duration_of': 'Set duration of [{msg}]',
  'class': 'Class',
  'from': 'From',
  'to': 'To',
  'test_result_of': 'Test result of [{msg}]',
  'more': 'More',
  'please_check_time_format': 'Please check time format',
  'please_enter_valid_datetime': 'Please enter valid date and time',
  'replace': 'Replace',
  'add_test': 'Add test',
  'select': 'Select',
  'test': 'Test',
  'level': 'Level',
  'time_used': 'Time(s) used',
  'preview': 'Preview',
  'download': 'Download',
  'please_name_this_test': 'Please name this test',
  'please_choose_a_test': 'Please choose a test',
  'finish': 'Finish',
  'test_completed': 'Test completed',
  'class_name': 'Class name',
  'teacher': 'Teacher',
  'list_of_students': 'List of students',
  'edit_list': 'Edit',
  'edit_class': 'Edit class',
  'add_class': 'Add class',
  'import_class_information': 'Import class information',
  'export_all_classes': 'Export all classes',
  'download_list_of_class': 'Download list of class',
  'list_of_class': 'Class List',
  'no_class_found': 'No class found',
  'file': 'File',
  'download_template': 'Download template',
  'class_management': 'Class',
  'class_information': 'Class information',
  'import_list_of_students': 'Import list of students',
  'add_current_student': 'Add current student(s)',
  'add_new': 'Add new',
  'remove': 'Remove',
  'add': 'Add',
  'at_least_4_characters': 'at least 4 characters',
  'name': 'Name',
  'student_id': 'Student ID',
  'no_assignment_found': 'No assignment found',
  'please_enter_course_name': 'Please enter course name',
  'update': 'Update',
  'add_course': 'Add course',
  'course_category': 'Course category',
  'daily_english': 'Daily English',
  'travel_shopping_english': 'Travel & Shopping English',
  'course_level': 'Course level',
  'show_selected': 'Show selected',
  'show_unselected': 'Show unselected',
  'course_has_not_been_saved_notice': 'Course has not been saved. Do you want to leave before saving?',
  'please_name_this_course': 'Please name this course',
  'please_choose_course': 'Please choose course(s)',
  'no_course_found': 'No course found',
  'my_favorites': 'My favorites',
  'all_courses': 'All courses',
  'new_course': 'New course',
  'course_assignment_deleting_confirm': 'By deleting the assignment, you will also delete the course record.',
  'add_recourse': 'Add recourse',
  'keyword': 'Keyword',
  'search': 'Search',
  'show_my_uploads_only': 'Show my upload(s) only',
  // 'view': 'View',
  'upload_files': 'Upload files',
  'file_formats': 'File formats',
  'picture_format_required': 'Picture: jpg, png (not more than 2M)',
  'video_format_required': 'Video: mp4 (not more than 25M)',
  'audio_format_required': 'Audio: mp3 (not more than 25M)',
  'online_resources_management': 'Online resources',
  'please_choose_a_file': 'Please choose a file',
  'by_course': 'By course',
  'by_assignment': 'By assignment',
  'by_test': 'By test',
  'no_result_found': 'No result found',
  'score': 'Score',
  'class_performance': 'Class performance ',
  'view_individual': 'View individual',
  'individual_student': 'Individual student',
  'statistics': 'Statistics',
  'assignment': 'Assignment',
  'test_history': 'Test history',
  'not_taken': 'Not taken',
  'view_details': 'View details',
  'test_assigned': 'Test assigned',
  'score_management': 'Score',
  'video': 'Video',
  'transcript': 'Transcript',
  'quiz': 'Quiz',
  'all': 'All',
  'times': 'Time(s)',
  'interactive': 'Interactive',
  'type': 'Type',
  'percentage': '%',
  'category': 'Category',
  'top_courses': 'Top courses',
  'course_reports': 'Course reports',
  'no_report_found': 'No report found',
  'learning_record': 'Learning record',
  'email': 'Email',
  'add_student': 'Add student',
  'import': 'Import',
  'export': 'Export',
  'no_student_found': 'No student found',
  'student_management': 'Student',
  'complete_list_of_students': 'Complete list of students',
  'add_teacher': 'Add teacher',
  'no_teacher_found': 'No teacher found',
  'teacher_management': 'Teacher',
  'complete_list_of_teachers': 'Complete list of teachers',
  'online_resources': 'Online resources',
  'message': 'Message',
  'history': 'History',
  'learning_record_mgr': 'Learning record',
  'live_AR': 'LiveAR',
  'live_VR': 'LiveVR',
  'live_Culture': 'LiveCulture',
  'tour_taiwan': 'TourTaiwan',
  'start_course': 'Start a new Course',
  'using_record': 'Lesson Record',
  'download_instructions': 'Download LiveCampus User Manual',
  'culture_function_menu': 'Live Culture function list',
  'select_unit': 'Please select any unit below',
  'choose_the_course': 'Please choose the course to start your learning',
  'click_icon_t': 'Please click',
  'click_icon_b': 'on the upper left corner to select your course.',
  'add_or_select': 'Add or select a class',
  'class_list': 'Class List',
  'add_or_delete_class': 'Add or delete student of the class',
  'complete': 'Complete',
  'established_date': 'Established Date',
  'student': '0 Student | 1 Student | {count} Students',
  'class_info': 'Class Info',
  'add_single_student': 'Add a single student',
  'batch_add_students': 'Batch add students with Excel file',
  'add_a_class': 'Add a class',
  'students_list': 'All Students',
  'selected_students': 'Selected Students',
  'enter_class_name': 'Please enter a class name …',
  'edit_class_list': 'Edit the class list',
  'please_enter_account_required': 'Please enter account…(Required)',
  'please_enter_password_required': 'Please enter password…(Required)',
  'please_enter_name_required': 'Please enter student name…(Required)',
  'please_enter_student_ID': 'Please enter student ID No.',
  'please_enter_account_rule': 'Please enter at least 6 letters(a-z) and numbers(0-9) + @ + organization abbr.',
  'sample_account': 'sample：live199@twes',
  'please_enter_password_rule': 'Please enter at least 6 letters(a-z) and numbers(0-9)',
  'please_enter_students_full_name': 'Please enter  students full name',
  'add_to_the_class': 'Add to the class',
  'upload_the_excel_file': 'Upload the excel file',
  'download_sample_excel_file': 'Download sample excel file',
  'click_to_select_file_upload': 'Click to select the file to upload (please select the file to upload from your computer)',
  'once_download': 'You can only upload one file at a time.',
  'upload_progress': 'Upload progress',
  'select_topic': 'Please select any topic below',
  'lessons': 'Lessons',
  'teachers_resources': `Teacher's Resources`,
  'course_list': 'Course list',
  'start_a_course': 'Start a course',
  'picture_dictionary': 'Picture dictionary',
  'select_resources_download': 'Please select the resources to download',
  'web_record': 'Web Record',
  'app_record': 'App Record',
  'using_records': 'Using Records',
  'start_new_course': 'Start a new course',
  'web_study_time': 'Web study time',
  'app_study_time': 'App study time',
  'web_schedule': 'Web schedule',
  'app_schedule': 'App schedule',
  'coins': 'Coins',
  'AR_unlocked': 'AR unlocked',
  'missions_completed': 'missions completed',
  'course_name': 'Course',
  'unit_theme': 'Unit Theme',
  'study_time': 'Study time',
  'views': 'Views',
  'oral_practice': 'Oral practice',
  // 'view': 'View',
  'click_below_detailed': 'Please click the button below to view the detailed lesson record of WEB or APP',
  'learning_contents': 'Learning contents',
  'last_update_time': 'Last updated time',
  'play': 'Play',
  'VR_function_list': 'Live VR Classroom Function List',
  'vocabulary_mission': 'Vocabulary mission',
  'saved_successfully': 'The list has been saved successfully',
  'added_vocabulary': 'Added new vocabulary words',
  'select them_to_column': 'Please select 7 words and add them to the right column',
  'scene': 'Scene',
  'character': 'Character(Npc)',
  'chance': 'Chance',
  'standard_score': 'Standard Score',
  'display': 'Display',
  'function': 'Function',
  'mistake': 'Mistake',
  'conversation_edit': 'Conversation edit',
  'selected_character': 'Character',
  'dialogue': 'Dialogue',
  'save': 'Save',
  'date': 'Date',
  'result': 'Result',
  'speech_image': 'Speech result image',
  'words_found': 'Words found',
  'general_list': 'General list',
  'story_mode': 'Story',
  'vocabulary_mode': 'Vocabulary',
  'conversation_mode': 'Conversation',
  'usage_time': 'Usage time',
  'total_usage_time': 'Total usage time',
  'selected': 'Selected',
  'all_selected': 'All',
  'valid_time': 'Serial valid time',
  'generate_serial': 'Generate serial number',
  'reminder': 'Friendly Reminder',
  'serial_number_rule': 'You will generate a serial number only for this account',
  'valid_until': 'Valid until',
  'your_serial_number': 'Your Serial number',
  'export_file': 'Export file',
  'fail': 'Fail',
  'pass': 'Pass',
  'success_serial_number': 'Success',
  'input_name': 'Please type the script title.',
  'symbols_rules': 'Only letters (a-z) and  the symbols ( ,.;!?) are allowed.',
  'save_editing_the_script': 'Please save the setting first before editing the script.',
  'added_mission': 'Added dialogue mission',
  'customer_support': 'Customer Support'
}



// WEBPACK FOOTER //
// ./src/locales/us_en.js